import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

// GDPR cookie consent banner (shown until a choice is stored).
export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie-consent")) setShow(true);
  }, []);

  if (!show) return null;

  const accept = (v) => { localStorage.setItem("cookie-consent", v); setShow(false); };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] rounded-xl border border-border bg-card shadow-xl p-4" data-testid="cookie-consent">
      <div className="flex items-center gap-2 text-sm text-foreground font-semibold mb-1">
        <Cookie className="w-4 h-4 text-primary" /> Informativa cookie
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed">
        Usiamo cookie tecnici necessari al funzionamento dell'app e, con il tuo consenso, cookie per migliorare l'esperienza.
        Leggi la <Link to="/cookie" className="text-primary underline inline-block py-1.5">Cookie Policy</Link> e l'<Link to="/privacy" className="text-primary underline inline-block py-1.5">Informativa Privacy</Link>.
      </p>
      <div className="flex gap-2 mt-3">
        <Button size="sm" variant="outline" className="flex-1" onClick={() => accept("necessary")} data-testid="cookie-reject">Solo necessari</Button>
        <Button size="sm" className="flex-1" onClick={() => accept("all")} data-testid="cookie-accept">Accetta tutti</Button>
      </div>
    </div>
  );
}
